import type { CustomContext } from "@rebuild/shared";
import Chip from "./Chip";
import type { DraftEntry } from "./customContext.types";

interface CustomContextTableProps {
  entries: CustomContext[];
  orgNameById: Map<string, string>;
  onSetDraft: (draft: DraftEntry | undefined) => void;
  onSetEntryToDelete: (draft: CustomContext) => void;
}

function CustomContextTable({ entries, orgNameById, onSetDraft, onSetEntryToDelete }: CustomContextTableProps) {
  return (
    <table className="w-full text-left border-collapse">
      <thead>
        <tr className="border-b border-gray-200">
          <th className="py-2 px-3 text-sm font-semibold text-gray-700 w-48">Title</th>
          <th className="py-2 px-3 text-sm font-semibold text-gray-700">Organizations</th>
          <th className="py-2 px-3 text-sm font-semibold text-gray-700 w-56">Estimate Types</th>
          <th className="py-2 px-3 text-sm font-semibold text-gray-700">Context</th>
          <th className="py-2 px-3 text-sm font-semibold text-gray-700 w-32">Actions</th>
        </tr>
      </thead>
      <tbody>
        {entries.map((entry) => (
          <tr key={entry.id} className="border-b border-gray-100 hover:bg-gray-50 align-top">
            <td className="py-2 px-3 text-gray-800 font-medium">{entry.title}</td>
            <td className="py-2 px-3 text-gray-600">
              <div className="flex flex-wrap gap-1">
                {entry.organizationIds.map((orgId) => (
                  <Chip key={orgId} label={orgNameById.get(orgId) ?? orgId} size="md" />
                ))}
              </div>
            </td>
            <td className="py-2 px-3 text-gray-600">
              <div className="flex flex-wrap gap-1">
                {entry.estimateTypes.map((estimateType) => (
                  <Chip key={estimateType} label={estimateType} />
                ))}
              </div>
            </td>
            <td className="py-2 px-3 text-gray-600">
              <span className="line-clamp-2">{entry.context}</span>
            </td>
            <td className="py-2 px-3">
              <div className="flex gap-2">
                <button
                  onClick={() =>
                    onSetDraft({
                      id: entry.id,
                      title: entry.title,
                      organizationIds: entry.organizationIds,
                      estimateTypes: entry.estimateTypes,
                      context: entry.context,
                    })
                  }
                  className="px-3 py-1 text-sm text-blue-600 hover:bg-blue-50 rounded-md"
                >
                  Edit
                </button>
                <button
                  onClick={() => onSetEntryToDelete(entry)}
                  className="px-3 py-1 text-sm bg-red-600 hover:bg-red-700 text-white rounded-md"
                >
                  Delete
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default CustomContextTable;
